import * as SwaggerAPI from './swaggerApi';
import { NonNullableObject } from './utils';

import { APIServerError } from 'utils/sra/types';

// generic
export enum APISortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type APIGenericList<ItemType> = {
  result: ItemType[];
  pageNumber: number;
  pageSize: number;
  count: number;
};

export type APIResponse<PayloadT> =
  | { error?: false; payload: PayloadT }
  | APIServerError;

// app module
export type APITenant = Required<NonNullableObject<SwaggerAPI.APITenantModel>>;
export type APIUserRegister = SwaggerAPI.APIUserRegisterModel;
export type APIUserTenant = SwaggerAPI.APIUserTenantModel & {
  isSelected: boolean;
};

export { APIUserRight } from './swaggerApi';
export type APIUserRightRequest = SwaggerAPI.APIUserRightsRequestModel;

export enum PrintType {
  Check = 'check',
  WhitePaper = 'whitepaper',
}

// user module
export {
  APIUserResetPasswordModel,
  APIUserSettingModel,
  APIUserSettingType,
  APIUserType,
} from './swaggerApi';

// setting module
export {
  APINumericOperators,
  APISettingName,
  APIStringOperators,
} from './swaggerApi';
export type APISetting = Required<NonNullableObject<SwaggerAPI.APISettingModel>>;

// user invite
export type APIUserInvite = SwaggerAPI.APIUserInviteModel;

// tenant module
export type APITenantSearchResult = APIGenericList<APITenant>;
export type APITenantSearchFilter = SwaggerAPI.APITenantQuerySearchFilter;

// Filter types
export type APIStringSearchFilter = SwaggerAPI.APIStringSearchFilter;
export type APIDecimalSearchFilter = SwaggerAPI.APIDecimalSearchFilter;
export type APIDateOnlySearchFilter = SwaggerAPI.APIDateOnlySearchFilter;
export type APIDateTimeSearchFilter = SwaggerAPI.APIDateTimeSearchFilter;

// user module
export type APIUser = Omit<Required<SwaggerAPI.APIUserModel>, 'userTenants'> & {
  userTenants: APIUserTenant[];
};

export type APIUserSearchResult = APIGenericList<APIUser>;
export type APIUserSearchFilter = SwaggerAPI.APIUserSearchFilter;

// audit module
export type APIAudit = Required<NonNullableObject<SwaggerAPI.APIAuditModel>>;
export type APIAuditSearchFilter = SwaggerAPI.APIAuditSearchFilter;
export type APIAuditSearchResult = APIGenericList<APIAudit>;
export { APIEventType, APIEntityType } from './swaggerApi';
